import React from "react";
import { View, Text } from "@react-pdf/renderer";

export default function EmisorSection({ S, data }) {
  return (
    <View style={[S.box]}>
      <Text style={S.label}>Datos del Emisor</Text>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          marginTop: 6,
        }}
      >
        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Emisor:</Text> {data.emisor}  BGBHNHNHNHNHNHNH
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>RUC:  </Text> {data.emisorRuc} 56777-788-888
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>DV: </Text> {data.emisorDv} 098 
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Dirección: </Text> {data.emisorDireccion}  EL PAICAL DE LA CHRORRERA CITTY
        </Text>
      </View>
    </View>
  );
}